import {
  CrudTableViewConfig,
  CrudViewColumnType,
  IconType,
  ActionBehavior
} from '@rappider/rappider-components/utils';

/**
 * List grid configuration for copied projects display
 *
 * Defines the table structure for displaying copied project modules
 * with columns for name, category, date, and description.
 */
export const copiedProjectsListGridConfig: CrudTableViewConfig = {
  columns: [
    {
      title: 'Image',
      fieldName: 'image',
      type: CrudViewColumnType.Image,
      visible: false // Hide in grid view but use for card view
    },
    {
      title: 'Module Name',
      fieldName: 'name',
      type: CrudViewColumnType.Text,
    },
    {
      title: 'Category',
      fieldName: 'categoryIds',
      type: CrudViewColumnType.Text,
    },
    {
      title: 'Copied Date',
      fieldName: 'copiedDate',
      type: CrudViewColumnType.Date,
    },
    {
      title: 'Description',
      fieldName: 'description',
      type: CrudViewColumnType.Text,
      width: '300px'
    }
  ],
  multipleSearchFields: ['name', 'description', 'copiedBy', 'copiedDate', 'categoryIds'],
  itemActions: [
    {
      name: 'delete-module',
      text: 'Delete',
      icon: {
        name: 'delete',
        type: IconType.NgZorro
      },
      tooltipText: 'Delete Module',
      behavior: ActionBehavior.Emit,
      popconfirmTitle: 'Are you sure to delete this module from your project?',
      popconfirmOkDanger: true,
      popconfirmOkText: 'Delete',
      emitWithoutPopconfirm: false
    }
  ],
  listActions: []
};
